export default __webpack_public_path__ + "atomic/_patterns/03-organisms/social-timeline/_social-timeline.twig";